module.exports = __webpack_public_path__ + "img/5.007828a5.png";